<template>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='create_role_name' :columns='columns' :data-source='data'></a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
</template>
<script>
  import { ref, onMounted, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getAllocationLog } from "@/api/antiFleeing";
  import { iscode } from "@/utils/app";
  let defSearch = {
    page: 1,
    limit: 5,
    id: ''
  };
  export default {
    components: {},
    name: "consultLog",
    props: {
      id: {
        type: Number
      },
    },
    setup(props, { emit }) {
      // 列表数据和列头配置
      const data = ref([]);
      const search = ref({ ...defSearch });
      const state = reactive({
        listLoading: false,
        total: 0,
      });
      let columns = [
        {
          title: "操作者",
          dataIndex: "create_role_name",
          key: "create_role_name"
        },
        {
          title: "操作动作",
          dataIndex: "action_type_text",
          key: "action_type_text",
        },
        {
          title: "信息",
          dataIndex: "content",
          key: "content",
        },
        {
          title: "时间",
          dataIndex: "created_at",
          key: "created_at",
        },
      ];
      // 分页当前页切换
      const pageCurrentChange = (page) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const initData = async () => {
        state.listLoading = true;
        let res = await getAllocationLog({ ...search.value, id: props.id }).then((res) => res.data);
        if (iscode(res)) {
          data.value = res.data;
          state.total = res.meta.total;
        } else {
          message.error(res.msg);
        }
        state.listLoading = false;
      };
      onMounted(() => {
        initData();
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageCurrentChange,
        pageSizeChange,
      };
    },
  };
</script>